import 'uni-pages';import 'uni-h5';import App from './App';

import axios from "axios";
Vue.prototype.$axios = axios;

//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//引入vuex
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate' // 引入数据持久化插件
Vue.use(Vuex);


// 创建store实例
const store = new Vuex.Store({
	state: {
		phone: '', //手机号
		token: '', //用户token
		userId: Math.floor(Math.random() * 1000), //用户id
		// userId: '20005557',
		coupons: [], //优惠券信息
		discount: 0, //折扣
		score: '', //用户积分
		beans: 0, //用户学豆
		purchasedBooks: [], //已购列表
		tbName: '', //教材名称
		amount: '', //总金额
		orderBooks: [], //订单教材
		confirmOrderParams: [], //确认订单参数
		total: '', //总价
	},
	mutations: {
		//更改手机号
		setPhone(state, data) {
			state.phone = data;
		},
		//更改用户id
		setUserId(state, data) {
			state.userId = data;
		},
		//更改优惠券信息
		setCoupon(state, data) {
			state.coupons = data;
		},
		//更改折扣信息
		setDisCount(state, data) {
			state.discount = data;
		},
		//更改积分信息
		setScore(state, data) {
			state.score = data;
		},
		//更改学豆信息
		setBeans(state, data) {
			state.beans = data;
		},
		//更改已购列表
		setBooks(state, data) {
			state.purchasedBooks = data;
		},
		//更改token
		setToken(state, data) {
			state.token = data;
		},
		//更改教材名称
		setTbName(state, data) {
			state.tbName = data;
		},
		//更改总金额
		setAmount(state, data) {
			state.amount = data;
		},
		//更改订单教材
		setOrderBooks(state, data) {
			state.orderBooks = data;
		},
		//更改确认订单参数
		setParams(state, data) {
			state.confirmOrderParams = data;
		},
		//更改总价
		setTotal(state, data) {
			state.total = data;
		},
		//更改教材id
		setTbId(state, data) {
			state.tbId = data;
		},
		//更改第三方key值
		setThirdKey(state, data) {
			state.thirdKey = data;
		},
		//更改底图宽度
		setBaseWidth(state, data) {
			state.baseWidth = data;
		},
		//更改底图高度
		setBaseHeight(state, data) {
			state.baseHeight = data;
		},
		//更改来源
		setOrigin(state, data) {
			state.origin = data;
		},
		//更改有效期
		setValidity(state, data) {
			state.validity = data;
		},
		//更改类型
		setType(state, data) {
			state.type = data;
		},
		//更改支付类型
		setPayType(state, data) {
			state.payType = data;
		},
		//更改订单id
		setOrderId(state, data) {
			state.orderId = data;
		},
		//更改pid
		setPid(state, data) {
			state.pid = data;
		},
		//更改bookUrl
		setBookUrl(state, data) {
			state.bookUrl = data;
		},
		//更改courseTypeName
		setCourseTypeName(state, data) {
			state.courseTypeName = data;
		},
		//更改courseName
		// setCourseName(state, data) {
		// 	state.courseName = data;
		// },
		//更改subjectId
		setSubjectId(state, data) {
			state.subjectId = data;
		},
		//更改gradeCode
		setGradeCode(state, data) {
			state.gradeCode = data;
		},
		//更改课程封面
		setImgCover(state, data) {
			state.imgCover = data;
		}
	},
	plugins: [createPersistedState({
		paths: ['coupons', 'discount', 'purchasedBooks', 'token', 'phone', 'userId', 'score',
			'beans', 'tbName', 'amount', 'orderBooks', 'confirmOrderParams', 'total', 'tbId',
			'thirdKey', 'baseWidth', 'baseHeight',
			'origin', 'validity', 'type', 'payType', 'orderId', 'pid', 'bookUrl', 'courseTypeName', 'subjectId', 'gradeCode', 'imgCover'
		] //是否控制持久化
	})]
})
Vue.prototype.$store = store;


let dev_pro = process.env.NODE_ENV; //获取环境变量
if (dev_pro == 'development') {
	//本地环境
	Vue.prototype.baseURL = 'https://dianducs.mypep.cn';
	Vue.prototype.baseApi = '/api';
	Vue.prototype.baseTeach = '/teach'; //教材列表

	Vue.prototype.baseURL_ = 'https://dianducs.mypep.cn/jx_click_api'; //获取token、用户鉴权、订单列表
	Vue.prototype.baseApi_ = '/methods';
	Vue.prototype.baseStatic = 'https://rjdduploadw.mypep.cn/test'; //锚点热区和教材底图、连读链、复读链
	Vue.prototype.baseResource = 'https://szjc-3.mypep.cn/test'; //资源鉴权
} else {
	if (location.hostname.indexOf('dianducs') >= 0) {
		//测试环境
		Vue.prototype.baseURL = 'https://dianducs.mypep.cn';
		Vue.prototype.baseApi = '';
		Vue.prototype.baseTeachUrl = 'https://rjddzy.mypep.cn'; //教材列表

		Vue.prototype.baseURL_ = 'https://dianducs.mypep.cn/jx_click_api'; //获取token、用户鉴权、订单列表
		Vue.prototype.baseApi_ = '';
		Vue.prototype.baseStatic = 'https://rjdduploadw.mypep.cn/test'; //锚点热区和教材底图、连读链、复读链
		Vue.prototype.baseResource = 'https://szjc-3.mypep.cn/test'; //资源鉴权
	} else {
		//正式环境
		Vue.prototype.baseURL = 'https://rjdiandu.mypep.cn';
		Vue.prototype.baseApi = '';

		Vue.prototype.baseURL_ = 'https://rjdiandu.mypep.cn'; //获取token、用户鉴权、订单列表
		Vue.prototype.baseApi_ = '';
		Vue.prototype.baseStatic = 'https://rjdduploadw.mypep.cn'; //锚点热区和教材底图、连读链、复读链
		Vue.prototype.baseResource = 'https://szjc-3.mypep.cn'; //资源鉴权			
	}
}


// Vue.prototype.version = '1.0.0'; //头信息添加版本
// Vue.prototype.version = '1.1.0'; //头信息添加版本
// Vue.prototype.version = '1.1.1'; //头信息添加版本
// Vue.prototype.version = '1.2.0'; //头信息添加版本
Vue.prototype.version = '1.3.0'; //头信息添加版本
Vue.prototype.app_channel = 'web'; //头信息添加渠道


import Rsa from "@/util/Rsa.js";
Vue.prototype.Rsa = Rsa; //将Rsa注册为公共方法,方便其他页面调用




import Vue from 'vue'
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
	...App
})
app.$mount()












